import {
  authorizedGetCall,
  authorizedPostCall,
  authorizedPutCall,
  authorizedDeleteCall,
} from "./APIsService";

export const getCategories = (search = null) => {
  return new Promise((resolve, reject) => {
    let url = `categories`;
    if (search) {
      url += `?searchQuery=${encodeURIComponent(search)}`;
    }

    authorizedGetCall(url)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const addCategory = (data) => {
  return new Promise((resolve, reject) => {
    authorizedPostCall(`categories`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const editCategory = (id, data) => {
  return new Promise((resolve, reject) => {
    authorizedPutCall(`categories/${id}`, data)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getParentCategories = () => {
  return new Promise((resolve, reject) => {
    authorizedGetCall(`categories/parent-categories`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const deleteCategory = (id) => {
  return new Promise((resolve, reject) => {
    authorizedDeleteCall(`categories/${id}`)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
